import { COLORS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  selectFormControlStyle: {
    flex: 1,
  },
  root: {
    fontWeight: 400,
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  focused: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  shrink: {
    fontWeight: 600,
    fontSize: '1rem',
    color: COLORS.GREY_DARKER,
    textTransform: 'uppercase',
  },
  selectRoot: {
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
});

export default styles;
